import { DEFAULT_STATE } from '../constants'

export const initialSortByState = {
  sortBy: DEFAULT_STATE.sortBy,
}
